import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <AnimatePresence data-id="element-264">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-50 backdrop-blur-sm" data-id="element-265" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-cream-100 rounded-2xl shadow-2xl z-50 max-h-[85vh] flex flex-col overflow-hidden" data-id="element-266">
            <div className="flex items-center justify-between p-6 border-b border-cream-200 bg-white" data-id="element-267">
              <h2 className="text-2xl font-heading font-bold text-forest-900" data-id="element-268">
                Terms of Service
              </h2>
              <button onClick={onClose} className="p-2 text-gray-500 hover:text-forest-700 hover:bg-cream-200 rounded-full transition-colors" aria-label="Close modal" data-id="element-269">
                <X size={24} data-id="element-270" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto prose prose-green max-w-none" data-id="element-271">
              <p className="text-sm text-gray-500 mb-6" data-id="element-272">
                Last Updated: {new Date().toLocaleDateString()}
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-273">
                1. Agreement to Terms
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-274">
                These Terms of Service constitute a legally binding agreement
                made between you, whether personally or on behalf of an entity
                ("you") and Pancho's Lawn Care ("we," "us" or "our"), concerning
                your access to and use of our landscaping and property
                maintenance services.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-275">
                2. Services Provided
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-276">
                Pancho's Lawn Care provides professional landscaping services
                including but not limited to sod installation, mulching, paver
                installation, pressure washing, and seasonal cleanups. All
                services will be performed in a professional, workmanlike manner
                consistent with industry standards.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-277">
                3. Estimates and Pricing
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-278">
                All estimates provided are based on the information available at
                the time of assessment. While we strive for accuracy, unforeseen
                conditions may require adjustments. Any significant changes to
                the scope of work or pricing will be communicated and agreed
                upon before proceeding.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-279">
                4. Payment Terms
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-280">
                Payment is typically due upon completion of the specified
                services unless a prior arrangement has been made. For larger
                projects, a deposit may be required before work commences.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-281">
                5. Cancellations and Rescheduling
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-282">
                We understand that plans change. We request at least 24 hours
                notice for any cancellations or rescheduling of routine
                services. Services may be rescheduled by us due to inclement
                weather or unforeseen circumstances.
              </p>
            </div>

            <div className="p-6 border-t border-cream-200 bg-white flex justify-end" data-id="element-283">
              <button onClick={onClose} className="px-6 py-2 bg-forest-700 text-white rounded-lg font-medium hover:bg-forest-900 transition-colors" data-id="element-284">
                Close
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}